export const GET_DIRECTORY_LIST = "/api/v2/directory/list";
export const GET_CHANNEL_LIST = "/api/v2/channel/all/list";
export const GET_GROUP_LIST = "/api/v2/group/list/withCount";
export const UPLOAD_GROUP_LOGO = "/api/v2/channel/upload/logo";
export const CREATE_CHANNEL_GROUP = "/api/v2/channel/create/group";
export const GET_CHANNEL_DETAIL = "/api/v2/channel/detail";
export const UPDATE_CHANNEL_DETAIL = "/api/v2/channel/detail/update";

export const GET_GROUP_DETAILS = "/api/v2/group/details";

export const CREATE_NEW_SUBSCRIPTION = "/api/v2/subscription/create";
export const GET_SUBSCRIPTION_LIST = "/api/v2/subscription/list";
export const GET_ALL_SUBSCRIPTION_LIST = "/api/v2/subscription/all/list";
export const GET_SUBSCRIPTION_DETAILS = "/api/v2/subscription/details";

export const ALLOCATION_STATUS_CHANGE = "/api/v2/subscription/allocation/status/change";
export const ALLOCATION_EXTEND = "/api/v2/subscription/extend/allocation";

export const ASSIGN_MODULE_LIST = "/api/v2/subscription/resource/list";
export const ASSIGN_APPLICATION_LIST = "/api/v2/subscription/application/list";

export const TAG_LIST = "/api/tag/list";

export const GET_CARDS_DATA = "/api/v2/dashboard/card/values";
export const GET_GRAPH_DATA = "/api/v2/dashboard/graph/values";

export const CREATE_CATEGORY = "/api/v2/category/create";
export const UPDATE_CATEGORY = "/api/v2/category/update";
export const DELATE_CATEGORY = "/api/v2/category/delete";
export const LIST_CATEGORY = "/api/v2/category/list";
export const CREATE_TAG = "/api/v2/category/tag/create";
export const UPDATE_TAG = "/api/v2/category/tag/update";
export const CATEGORY_TAGS_LIST = "/api/v2/category/tags/list";
export const CATEGORY_ALL_SUBCATEGORY = "/api/v2/category/sub/category/list";

export const REVENUE_RATE = "/api/v2/dashboard/revenue/rate";

export const TABLEAU_REVENUE_GRAPH = "/api/v2/dashboard/tablue";

export const FETCH_RETENTION_AND_CHURN_RATE = "/api/v2/dashboard/retention-rate";
